import * as R from "ramda";
import { validateObject, validateField } from "util/validation";
import { notBlank } from "../../util/ext";
import { curry } from "ramda";

const moduleConstraints = {
  name: {
    presence: {
      allowEmpty: false,
      message: "^Module title can't be blank",
    },
  },
  /**
   * description.format.pattern should catch any text that is empty or only contains whitespaces
   * react-rte passes <p><br></p> if text box is empty
   * react-rte also passes white spaces as '&nbsp;'
   */
  description: {
    presence: {
      allowEmpty: false,
      message: "^Description must not be blank",
    },
    format: {
      pattern: /^(?!\s*(?:<p>\s*(?:&nbsp;|<br\s*\/?>|\s)+\s*<\/p>\s*)+$)[\s\S]*$/,
      message: "^Description must not be blank",
    },
  },
  displayName: {
    presence: {
      allowEmpty: false,
      message: "^Module display name can't be blank",
    },
  },
  iconUrl: {
    presence: {
      allowEmpty: false,
      message: "^A thumbnail image is required",
    },
  },
  internalCode: {
    presence: {
      allowEmpty: false,
      message: "^Identifier code is required",
    },
  },
};

const newModuleConstraints = {
  name: {
    presence: {
      allowEmpty: false,
      message: "^Module title can't be blank",
    },
  },
  description: {
    presence: {
      allowEmpty: false,
      message: "^Description must not be blank",
    },
  },
};

export const validateModuleField = (field, value, errors = {}) =>
  validateField(moduleConstraints, field, value, errors);

export const validateNewModuleField = (field, value, errors = {}) =>
  validateField(newModuleConstraints, field, value, errors);

export const validateModule = R.partial(validateObject, [moduleConstraints]);

export const validateNewModule = R.partial(validateObject, [
  newModuleConstraints,
]);

export const hasError = curry((errors, field) => notBlank(errors[field]));

export const firstError = curry((errors, field) =>
  errors[field] ? errors[field][0] : "",
);
